import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { SmoothScroll } from "@/components/SmoothScroll";
import Home from "@/pages/Home";
import LifestyleTraining from "@/pages/LifestyleTraining";
import ProductPage from "@/pages/ProductPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import NutriApp from "@/pages/NutriApp";
import SoftSkillsTest from "@/pages/SoftSkillsTest";
import CoachingOnline from "@/pages/CoachingOnline";
import AboutMe from "@/pages/AboutMe";
import TestimonialsPage from "@/pages/TestimonialsPage";
import Sources from "@/pages/Sources";
import EthicalAI from "@/pages/EthicalAI";
import CoachingCheckup from "@/pages/CoachingCheckup";
import CoachingEnrollment from "@/pages/CoachingEnrollment";
import { CustomerProvider } from "@/context/CustomerContext";
import { AuthCallback } from "@/components/AuthCallback";

function OldEnrollmentRedirect() {
  const { token } = useParams();
  const { search } = useLocation();
  return <Navigate to={`/training-online/iscrizione/${token}${search}`} replace />;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/catalogo" element={<Navigate to="/" replace />} />
      <Route path="/lifestyle-training" element={<LifestyleTraining />} />
      <Route path="/prodotto/:id" element={<ProductPage />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/:section" element={<AdminDashboard />} />
      <Route path="/app" element={<NutriApp />} />
      <Route path="/test-soft-skills" element={<SoftSkillsTest />} />
      <Route path="/training-online" element={<CoachingOnline />} />
      <Route path="/chi-sono" element={<AboutMe />} />
      <Route path="/testimonianze" element={<TestimonialsPage />} />
      <Route path="/fonti" element={<Sources />} />
      <Route path="/uso-etico-ia" element={<EthicalAI />} />
      <Route path="/training-online/primo-passo" element={<CoachingCheckup />} />
      <Route path="/training-online/iscrizione/:token" element={<CoachingEnrollment />} />
      <Route path="/coaching-online" element={<Navigate to="/training-online" replace />} />
      <Route path="/coaching-online/primo-passo" element={<Navigate to="/training-online/primo-passo" replace />} />
      <Route path="/coaching-online/iscrizione/:token" element={<OldEnrollmentRedirect />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="grain min-h-screen bg-[#050807]">
      <BrowserRouter>
        <AuthProvider>
          <CustomerProvider>
          <CartProvider>
            <SmoothScroll />
            <AppRouter />
            <Toaster theme="dark" position="bottom-left" toastOptions={{ style: { background: "#0b120e", border: "1px solid rgba(152,191,162,.3)", color: "#f4f7f5" } }} />
          </CartProvider>
          </CustomerProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
